export const localhost = "https://homepage.rainscales.com.vn";
// export const localhost = "http://10.2.21.89:8081";
// export const localhost = "https://homepage.dri-a.site";
